<template>
  <div class="mobile-app-view default-page">
    <img
      :src="bannerImage"
      alt="Акція 6+1 від Crystal"
      class="default-page__banner mb-5"
    />
    <h1>Завантажуйте My Crystal</h1>
    <div class="default-page-section">
      Щоб активувати акції, завантажуйте наш фірмовий застосунок. Там є все
      необхідне!
    </div>
    <div class="default-page-section">
      <mobile-app-tiles />
    </div>
    <div class="default-page-section mb-0">
      <a
        href="https://play.google.com/store/apps/details?id=com.utg.mycrystalclient&pli=1"
        target="_blank"
      >
        <app-btn class="btn btn-primary w-100 mb-3"> Для Android </app-btn>
      </a>
      <a
        href="https://apps.apple.com/us/app/my-crystal/id1552356780?platform=iphone"
        target="_blank"
      >
        <app-btn class="btn btn-primary w-100"> Для iOS </app-btn>
      </a>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import MobileAppTiles from "@/components/mobile-app/MobileAppTiles.vue";
import bannerImage from "@/assets/mobile-app/banner-mobile-application.jpg";

export default {
  name: "MobileAppView",
  components: {
    AppBtn,
    MobileAppTiles,
  },
  setup() {
    return {
      bannerImage,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins.less";

.mobile-app-view {
  .default-page-section {
    .default-ul-list();
  }
}
</style>
